import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'field', 'input'];
  static values = { freeText: String };

  connect() {
    this.updateVisibility();
  }

  toggleVisibility() {
    this.updateVisibility();
    this.saveSelection();
  }

  updateVisibility() {
    const freeTextChecked = this.checkboxTargets.some(
      (checkbox) => checkbox.value === this.freeTextValue && checkbox.checked,
    );

    if (freeTextChecked) {
      this.fieldTarget.classList.remove('hide');
    } else {
      this.fieldTarget.classList.add('hide');
      this.inputTarget.value = '';

      const event = new Event('change');
      this.inputTarget.dispatchEvent(event);
    }
  }

  saveSelection() {
    const firstCheckbox = this.checkboxTargets[0];
    if (!firstCheckbox) return;

    const url = firstCheckbox.dataset.url;
    if (!url) return;

    const selectedValues = this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    const params = selectedValues
      .map(
        (v) => `item[attendee_dietary_requirement][]=${encodeURIComponent(v)}`,
      )
      .join('&');
    const body =
      selectedValues.length > 0
        ? params
        : 'item[attendee_dietary_requirement][]=';

    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
          .content,
        Accept: 'text/vnd.turbo-stream.html',
      },
      body: body,
    }).then((r) => {
      if (r.ok && r.status !== 204) {
        r.text().then((html) => window.Turbo?.renderStreamMessage(html));
      }
    });
  }
}
